import React, { useState, useEffect } from 'react';
import './TextInput.css'

const TextInput = (props) => {
  const [errorMsg, setErrorMsg] = useState('')

  useEffect(() => {
    if (props && props.error) {
      if (Object.keys(props.error).length) {
        Object.entries(props.error).forEach(([key, value]) => {
          if (key === props.name) {
            setErrorMsg(value.toString())
          }
        })
      } else if (errorMsg.length) {
        setErrorMsg('')
      }
    }
  }, [props, errorMsg])

  return (
    <div className={ `coral-Form-fieldwrapper ${(errorMsg && errorMsg.length) ? 'error' : ''}` } style={{display: (props.hidden) ? 'none' : 'block'}}>
      <label className="coral-Form-fieldlabel">
        { props.label }
        <small className="required-label">{ props['data-required'] ? `${ props['data-required-label'] }`: '' }</small>
      </label>
      <input 
        className={ `coral-Form-field coral-Textfield ${(errorMsg && errorMsg.length) ? 'is-invalid' : ''}` }
        { ...props }
      />
      <span className={ `${(errorMsg && errorMsg.length) ? 'help-block field-error' : ''}` }>{ errorMsg }</span>
    </div>
  )
}

export default TextInput;